<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 10px">
          基本信息
        </div>
        <div class="info-form">
          <el-form-item
            label="姓名"
            prop="name"
            :rules="[
              { required: true, message: '请填写姓名', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="手机号"
            prop="phone"
            :rules="[
              {
                required: true,
                message: '请填写手机号',
                trigger: 'blur',
              },
              {
                validator: phone_rules,
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.phone"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="state.model.sex">
              <el-radio value="男">男</el-radio>
              <el-radio value="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="证件类型"
            prop="idtype"
            :rules="[
              { required: true, message: '请选择证件类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.idtype">
              <el-option
                v-for="item in state.idTypeData"
                :key="item"
                :label="item.name"
                :value="item.name"
              />
              <template #footer>
                <el-button size="small" @click="onLoadIdType()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="证件号"
            prop="idcard"
            :rules="[
              { required: true, message: '请填写证件号', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.idcard"></el-input>
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          申报信息
        </div>
        <div class="info-form">
          <el-form-item label="在职状态">
            <el-switch
              v-model="state.model.status"
              inline-prompt
              active-text="在职"
              active-color="#1e90ff"
              inactive-text="离职"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
            />
          </el-form-item>
          <el-form-item
            label="属性"
            prop="property"
            :rules="[
              { required: true, message: '请选择员工属性', trigger: 'blur' },
            ]"
          >
            <el-radio-group v-model="state.model.property">
              <el-radio :label="0">雇员</el-radio>
              <el-radio :label="1">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="所属客户"
            prop="customer_id"
            :rules="[
              { required: true, message: '请选择客户', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.customer_id"
              placeholder="--选择所属客户--"
              disabled
            >
              <el-option
                v-for="item in state.customerData"
                :key="item.id"
                :label="item.alias + '(' + item.name + ')'"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadCustomer()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="扣缴义务人类型"
            prop="withholding_agent_type"
            :rules="[
              {
                required: true,
                message: '请选择扣缴义务人类型',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group
              v-model="state.model.withholding_agent_type"
              @change="onTypeChange"
            >
              <el-radio :label="0">扣缴义务人</el-radio>
              <el-radio :label="1">供应商</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="state.model.withholding_agent_type == 0"
            label="扣缴义务人"
            prop="withholding_agent_id"
            :rules="[
              {
                required: true,
                message: '请选择扣缴义务人',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.withholding_agent_id"
              placeholder="--选择扣缴义务人--"
              size="large"
            >
              <el-option
                v-for="item in state.withholdingagentData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadWithholdingAgent()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="state.model.withholding_agent_type == 1"
            label="供应商"
            prop="withholding_agent_id"
            :rules="[
              {
                required: true,
                validator: (rule, value, callback) => {
                  if (!state.model.withholding_agent_id)
                    callback(new Error('请选择供应商'));
                  else if (!state.model.settle_unit_id)
                    callback(new Error('请选择结算单位'));
                  else callback();
                },
                trigger: 'blur',
              },
            ]"
          >
            <div style="display: flex; align-items: center; width: 100%">
              <el-select
                v-model="state.model.withholding_agent_id"
                placeholder="--选择供应商--"
                style="flex: 1"
                @change="onSupplierChange"
              >
                <el-option
                  v-for="item in state.supplierData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadSupplier()">
                    刷新
                  </el-button>
                </template>
              </el-select>
              <el-select
                v-model="state.model.settle_unit_id"
                placeholder="--选择结算单位--"
                size="large"
                style="flex: 1; margin-left: 10px"
              >
                <el-option
                  v-for="item in state.settleunitData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadSettleUnit()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="签约单位"
            prop="contract_unit_id"
            :rules="[
              { required: true, message: '请选择签约单位', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.contract_unit_id"
              placeholder="--选择签约单位--"
              size="large"
            >
              <el-option
                v-for="item in state.contractUnitData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadContractUnit()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="入职时间"
            prop="entry_time"
            :rules="[
              { required: true, message: '请选择入职时间', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.entry_time"
              type="date"
              placeholder="--入职时间--"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="离职时间">
            <el-date-picker
              v-model="state.model.resignation_time"
              type="date"
              placeholder="--离职时间--"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item label="所属客服">
            <el-input v-model="state.model.username" disabled></el-input>
          </el-form-item>
          <el-form-item
            label="服务费承担方式"
            prop="service_cost_mode"
            :rules="[
              {
                required: true,
                message: '请选择服务费承担方式',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.model.service_cost_mode">
              <el-radio-button :value="0">员工</el-radio-button>
              <el-radio-button :value="1">公司</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务费计算方式" style="width: 66.66%">
            <div style="display: flex; align-items: center">
              <el-config-provider
                :value-on-clear="null"
                :empty-values="[undefined, null]"
              >
                <el-select
                  v-model="state.model.service_cost_calc_mode"
                  placeholder="计算基数"
                  style="width: 200px"
                >
                  <el-option label="无" :value="0" />
                  <el-option label="应发工资" :value="1" />
                  <el-option label="应发工资-代扣项目" :value="2" />
                </el-select>
                <el-input-number
                  v-model="state.model.service_cost_calc_rate"
                  :controls="false"
                  class="number-input-left number-input-suffix"
                  :precision="2"
                  suffix="%"
                  style="width: 100px; margin-left: 5px"
                ></el-input-number>
                <text style="font-size: 30px; margin-left: 5px; color: #626262">
                  +
                </text>
                <el-select
                  v-model="state.model.service_cost_type"
                  placeholder="收费类型"
                  style="width: 120px; margin-left: 5px"
                >
                  <el-option label="无" :value="0" />
                  <el-option label="每人每月" :value="1" />
                  <el-option label="每人每笔" :value="2" />
                </el-select>
                <el-input-number
                  v-model="state.model.service_cost"
                  :controls="false"
                  class="number-input-left number-input-suffix"
                  :precision="2"
                  suffix="元"
                  style="width: 100px; margin-left: 5px"
                ></el-input-number>
              </el-config-provider>
            </div>
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          收款信息
        </div>
        <div class="info-form">
          <el-form-item
            label="开户银行"
            prop="bank"
            :rules="[
              { required: true, message: '请选择开户银行', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.bank"
              placeholder="开户银行"
              size="large"
            >
              <el-option
                v-for="item in state.bank_data"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="银行卡号"
            prop="bank_account"
            :rules="[
              { required: true, message: '请填写银行卡号', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.bank_account" />
          </el-form-item>
          <el-form-item label="开户行支行">
            <el-input v-model="state.model.opening_bank" />
          </el-form-item>
          <el-form-item label="开户行省份">
            <el-select
              v-model="state.model.opening_bank_province"
              placeholder="开户行省份"
              size="large"
            >
              <el-option
                v-for="item in state.openbank_province_data"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
              <template #footer>
                <el-button size="small" @click="onLoadOpenBankProvince()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="异卡发放">
            <el-switch
              v-model="state.model.is_diff_bank"
              inline-prompt
              :active-value="1"
              :inactive-value="0"
            />
            <text style="color: #f00; margin-left: 20px">
              注：异卡发放需财务审核后才生效
            </text>
          </el-form-item>
          <el-form-item
            label="户名"
            prop="bank_account_name"
            :rules="[
              {
                required: state.model.is_diff_bank,
                message: '请填写户名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.bank_account_name"
              :disabled="!state.model.is_diff_bank"
            />
          </el-form-item>
          <el-form-item
            v-if="state.model.is_diff_bank"
            label="异卡申请说明"
            prop="diff_bank_reason"
            :rules="[
              {
                required: state.model.is_diff_bank,
                message: '请填写异卡申请原因',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.diff_bank_reason"
              :disabled="!state.model.is_diff_bank"
            />
          </el-form-item>
          <el-form-item
            v-if="state.model.is_diff_bank"
            label="异卡证明文件"
            prop="diff_bank_attachment"
            :rules="[
              {
                required: true,
                message: '请上传异卡证明文件',
                trigger: 'blur',
              },
            ]"
            style="width: 66%"
          >
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onFileChange"
            >
              <template #trigger>
                <el-button type="primary" size="small">上传</el-button>
              </template>
            </el-upload>
            <a
              v-if="state.fileModel?.sourcename"
              :href="state.fileModel?.file_url"
              target="_blank"
              style="margin-left: 10px"
            >
              {{ state.fileModel?.sourcename }}
            </a>
          </el-form-item>
        </div>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { customer_employee_add } from "@/http/customer";
import {
  data_withholdingagent_select,
  data_supplier_select,
  data_settleunit_select,
  data_customer_select,
  data_contractunit_select,
} from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/qFormat";
import {
  idtype_select,
  openbank_province_select,
  bank_select,
} from "@/http/dictionary";
import store from "@/store";
import { ElMessageBox } from "element-plus";
import { phone_rules } from "@/utils/rules";

export default {
  props: {
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        job_status: 1,
        is_diff_bank: 0,
        withholding_agent_type: 0,
      },
    });
    onMounted(() => {
      onLoadIdType();
      onLoadWithholdingAgent();
      onLoadContractUnit();
      onLoadCustomer();
      onLoadBank();
      onLoadOpenBankProvince();

      state.model.username =
        store.state?.loginUser?.name +
        "/" +
        store.state?.loginUser?.department_name;
    });

    //获取证件类型
    const onLoadIdType = () => {
      idtype_select().then((res) => {
        if (res.status == 200) {
          state.idTypeData = res.data.data;

          if (!state.model.idtype) {
            state.model.idtype = state.idTypeData.find((w) =>
              w.name.includes("身份证")
            )?.name;
          }
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) {
          state.customerData = res.data.data?.list;
          state.model.customer_id = props.customer_id;
          const item = state.customerData.find(
            (w) => w.id == props.customer_id
          );
          state.model.service_cost_calc_mode = item.service_cost_calc_mode;
          state.model.service_cost_calc_rate = item.service_cost_calc_rate;
          state.model.service_cost_type = item.service_cost_type;
          state.model.service_cost = item.service_cost;
        }
      });
    };

    //获取扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200) state.withholdingagentData = res.data.data?.list;
      });
    };

    //获取供应商
    const onLoadSupplier = () => {
      data_supplier_select().then((res) => {
        if (res.status == 200) state.supplierData = res.data.data?.list;
      });
    };

    //供应商改变事件
    const onSupplierChange = () => {
      delete state.model.settle_unit_id;
      delete state.settleunitData;
      setTimeout(() => {
        onLoadSettleUnit();
      }, 200);
    };

    //加载结算单位
    const onLoadSettleUnit = () => {
      data_settleunit_select(state.model.withholding_agent_id).then((res) => {
        if (res.status == 200) state.settleunitData = res.data.data?.list;
      });
    };

    //获取签约单位
    const onLoadContractUnit = () => {
      data_contractunit_select().then((res) => {
        if (res.status == 200) state.contractUnitData = res.data.data?.list;
      });
    };

    //扣缴义务人类型改变事件
    const onTypeChange = (value) => {
      delete state.model.withholding_agent_id;
      delete state.model.settle_unit_id;
      if (value == 1) {
        onLoadSupplier();
      }
    };

    //获取开户银行
    const onLoadBank = () => {
      bank_select().then((res) => {
        state.bank_data = res.data.data;
      });
    };

    //获取开户行省份
    const onLoadOpenBankProvince = () => {
      openbank_province_select().then((res) => {
        state.openbank_province_data = res.data.data;
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.fileModel = res.data.data[0];
          state.fileModel.sourcename = file.name;
          state.model.diff_bank_attachment = state.fileModel.id;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.is_diff_bank) {
            if (state.model.bank_account_name == state.model.name) {
              ElMessageBox.confirm(
                "异卡户名与员工姓名一致，是否继续提交？",
                "提示",
                {
                  confirmButtonText: "确认提交",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                onPost();
              });
            } else {
              onPost();
            }
          } else {
            onPost();
          }
        }
      });
    };

    const onPost = () => {
      state.model.belonger_id = store.state.loginUser?.id;
      state.model.belonger_department_id = store.state.loginUser?.department_id;

      customer_employee_add(state.model).then((res) => {
        post_response(res, emit);
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadIdType,
      onLoadWithholdingAgent,
      onLoadContractUnit,
      onLoadCustomer,
      onSubmit,
      onTypeChange,
      onLoadSupplier,
      onSupplierChange,
      onLoadSettleUnit,
      onFileChange,
      phone_rules,
      onLoadOpenBankProvince,
    };
  },
};
</script>
<style scoped lang="less"></style>
